import * as ActionTypes from "../constants/actionTypes"
import { UPDATE_CAMERA_MIC_ACCESS_AVAILABLE_STATUS } from "../constants/actionTypes"

function init(): boolean {
	return true
}

export const cameraMicAccessReducer = function (initialState = init(), action: any) {
	switch (action.type) {
		case ActionTypes.UPDATE_CAMERA_MIC_ACCESS_AVAILABLE_STATUS:
			return action.payload
		default:
			return initialState
	}
}
